import { useMutation } from '@apollo/client'
import { RequestGroupTestSession, RequestGroupTestSessionVariables } from '../../types'
import { REQUEST_GROUP_TEST_SESSION } from './operations'

export const useRequestGroupTestSession = () => {
  const requestGroupTestSession = useMutation<
    RequestGroupTestSession,
    RequestGroupTestSessionVariables
  >(REQUEST_GROUP_TEST_SESSION)

  return requestGroupTestSession
}
